export interface ValidationResult {
    valid: boolean;
    message: string;
    values?: { [key: string]: any };
}

/**
 * Abstract base class for all rule validators.
 */
export abstract class RuleValidator {
  /**
   * Parses the provided rule and returns a RuleValidator instance if valid.
   * @param {string} rule - The rule string to be parsed.
   * @returns {RuleValidator | null} - An instance of RuleValidator or null if the rule is not valid.
   */
  static parse(rule: string): RuleValidator | null {
    throw new Error("Method not implemented.");
  }

  /**
   * Returns the rule message.
   * @returns {string} - The rule validation message.
   */
  public abstract getValidationMessage(): string;

  /**
   * Applies the rule to the provided value and returns whether the value is valid, along with an information message.
   * @param {string} value - The value to be validated.
   * @returns {ValidationResult} - An object containing the validation result and the information message.
   */
  public abstract apply(value: string): ValidationResult;
}
